import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconBoardSettingsM: FC<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 1C2.34315 1 1 2.34315 1 4V12C1 13.6569 2.34315 15 4 15H12C13.6569 15 15 13.6569 15 12V4C15 2.34315 13.6569 1 12 1H4ZM2 4C2 2.89543 2.89543 2 4 2H12C13.1046 2 14 2.89543 14 4L2 4ZM2 5H14V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V5Z" />
  </svg>
)

export const IconBoardSettings = createIcon({
  name: 'IconBoardSettings',
  l: IconBoardSettingsM,
  m: IconBoardSettingsM,
  s: IconBoardSettingsM,
  xs: IconBoardSettingsM,
})
